<template>
  <div>
    <div>
      <span class="cs-title cs-bold">基本信息</span>
    </div>
    <div>
      <table>
        <tr>
          <td class="cs-label">
            <span>电话号码</span>
          </td>
          <td>
            <span>{{USERMANAGER.canViewFullPhone ? studentInfoData.Phone : studentInfoData.PhoneAbbr}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>姓名</span>
          </td>
          <td>
            <span>{{studentInfoData.FullName}}</span>
          </td>
        </tr>

        <tr>
          <td class="cs-label">
            <span>学校</span>
          </td>
          <td>
            <span>{{studentInfoData.UniversityGroupText}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>邮箱</span>
          </td>
          <td>
            <span>{{studentInfoData.Email}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>报名日期</span>
          </td>
          <td>
            <span>{{studentInfoData.CreateDateText}}</span>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    studentInfoData: Object,
  },
  data() {
    return {
    };
  },
  created() {

  },
  computed: {
   
  },
  methods: {
    
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
td {
  padding-right: 10px;
  line-height: 28px;
  height: 28px;
}

.cs-label {
  min-width: 75px;
}

.el-divider {
  &.el-divider--vertical {
    height: 100%;
    margin: 0 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/studentInfo.vue